/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_4_TitleInputs */

const et_portfolio_project_4_title = /** @type {(inputs: Portfolio_Project_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google top 1 kakaotööstuses 60 päevaga – kohalik kliendivoog avatud.`)
};

const en_portfolio_project_4_title = /** @type {(inputs: Portfolio_Project_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranked top 1 in Cacao industry in 60 days - unlocked local customer flow.`)
};

/**
* | output |
* | --- |
* | "Ranked top 1 in Cacao industry in 60 days - unlocked local customer flow." |
*
* @param {Portfolio_Project_4_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_4_title = /** @type {((inputs?: Portfolio_Project_4_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_4_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_4_title(inputs)
	return en_portfolio_project_4_title(inputs)
});